import { useState, useEffect } from "react";
import {
  hasPermission,
  hasPermissionKey,
  getUserPermissions,
  isSuperAdmin,
  isAdmin,
} from "utils/permissionUtils";

/**
 * Gate on a single new-scheme permission key (e.g. P.INVOICE.UPDATE), with legacy-alias
 * fallback. Returns a boolean; usable directly in render for conditional UI.
 */
export const usePermission = (requiredKey) => hasPermissionKey(requiredKey);

export const usePermissions = () => {
  const [permissions, setPermissions] = useState({
    userDetail: null,
    permittedModules: [],
    isLoading: true,
  });

  useEffect(() => {
    const loadPermissions = () => {
      try {
        const { userDetail, permittedModules } = getUserPermissions();
        setPermissions({
          userDetail,
          permittedModules,
          isLoading: false,
        });
      } catch (error) {
        console.error("Error loading permissions:", error);
        setPermissions({
          userDetail: null,
          permittedModules: [],
          isLoading: false,
        });
      }
    };

    loadPermissions();
  }, []);

  const checkPermission = (requiredPermission) => {
    return hasPermission(requiredPermission);
  };

  const checkMultiplePermissions = (requiredPermissions) => {
    if (!requiredPermissions || !Array.isArray(requiredPermissions)) {
      return false;
    }

    return requiredPermissions.some((permission) => hasPermission(permission));
  };

  return {
    ...permissions,
    checkPermission,
    checkMultiplePermissions,
    isSuperAdmin: isSuperAdmin(),
    isAdmin: isAdmin(),
    hasPermission: checkPermission,
  };
};
